module.exports = __webpack_public_path__ + "files/31d7d94b9de8a725955fab0bd283c0e7.png";